var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainNoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1710 350",
    style: {
      enableBackground: "new 0 0 1710 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#18181B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,239.1v23c0,21.9,5.4,32,20,32c14.7,0,18.2-15,18.2-30.7c0-31.4-5.9-40.4-39.8-68.8 C25,162.9,5.7,144.1,5.7,95.2C5.7,47.7,21.4,4,84.4,4c66.8,0,76.7,45.6,76.7,83.6v19.1h-60.3V86.8c0-20.2-3.3-30.1-15.9-30.1 c-11.8,0-15.6,10.1-15.6,29c0,20,3.6,29.9,31.1,51.3c48.9,38.4,66.4,60,66.4,114.7c0,52-17.8,94.9-83.8,94.9 c-63.4,0-81.5-38.2-81.5-87.5v-19.9H64V239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.5,65.7h-48.4V9.2H339v56.5h-48.7v275.8h-63.8L226.5,65.7L226.5,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.5,197.1v144.5h-63.8V9.2h82.9c55.7,0,83.2,24.5,83.2,82.6v12c0,47.4-18.9,61.4-33.2,68.2 c20.7,10,30.4,25.2,30.4,71.5c0,32.1-0.5,80.6,2.3,98.1h-61.8c-4.1-15-3.8-58.3-3.8-100.7c0-37.4-4.3-43.8-28.6-43.8H425.5 L425.5,197.1z M425.7,146.7h7.9c21.3,0,30.1-6.7,30.1-37.7V93c0-22.3-4.5-33.4-28-33.4h-10V146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620.8,262.4l-8.2,79.1h-65.2l47-332.3h95.3l48.1,332.3h-66.5l-9.2-79.1H620.8z M656.7,206.1 c-4.7-42.5-11.3-107.2-14.5-139h-2.5c-1.1,23.2-9,97.9-13.4,139H656.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.8,65.7h-48.4V9.2h160.9v56.5h-48.7v275.8h-63.8V65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M948.4,262.4l-8.2,79.1H875L922,9.2h95.3l48.1,332.3h-66.5l-9.2-79.1H948.4z M984.4,206.1 c-4.7-42.5-11.3-107.2-14.5-139h-2.5c-1.1,23.2-9,97.9-13.4,139H984.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1109.3,9.9v332.6h-19.1V9.9H1109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1162.9,342.5V9.9h24.7c22.7,76.5,75.7,261.3,83.1,298.2h1c-1.5-48.6-2.5-95.4-2.5-149.2V9.9h19.1v332.6h-24.1 c-25.1-85.6-76.2-269.4-85.5-308.6h-0.5c2,39.8,3.9,101.2,3.9,161.5v147.2L1162.9,342.5L1162.9,342.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1371.1,27.5h-54.3V9.9h126.7v17.6h-53.3v315.1h-19.1L1371.1,27.5L1371.1,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1565.3,172.1h-76.1v152.8h85.1l-3.1,17.6H1470V9.9h99.7v17.6h-80.5v127.1h76.1V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1606,9.9h19.1V325h83.7l-3.5,17.6H1606V9.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNoIcon);
export default __webpack_public_path__ + "static/media/main-no-icon.5b2738b7b4e1532d56da0e3b956508d0.svg";
export { ForwardRef as ReactComponent };